import { PropsWithChildren } from 'react'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { SUPPORT_PHONE } from '../../constants/types'
import { sxs } from './style'
import { SupportHelpIcon } from '../../assets/icons/icons'

export const SingleCenteredCardLayout = ({ children }: PropsWithChildren) => (
    <Box sx={sxs.page}>
        <Box sx={sxs.card}>{children}</Box>

        <Box sx={sxs.support}>
            <SupportHelpIcon style={{ width: '2.25rem', height: '2.25rem' }} />
            <Typography component="p" sx={sxs.supportText}>
                Assistance disponible
                <br />
                au{' '}
                <Link href={`tel:${SUPPORT_PHONE.replace(/\./g, '')}`} sx={sxs.supportLink}>
                    {SUPPORT_PHONE}
                </Link>
            </Typography>
        </Box>
    </Box>
)
